import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Paperclip, Loader2, Eye, X } from "lucide-react";

// value: {id, url, original_filename, content_type} | null
export function ReceiptField({ value, onChange }) {
  const { orgId } = useAuth();
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const fd = new FormData();
    fd.append("file", f);
    setBusy(true);
    try {
      const { data } = await api.post("/api/uploads", fd, {
        params: { organization_id: orgId }, headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data);
      toast.success("Justificatif ajouté");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Échec de l'envoi");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  const view = async () => {
    try {
      const { data } = await api.get(`/api/files/${value.id}`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      window.open(url, "_blank", "noopener");
    } catch {
      toast.error("Impossible d'ouvrir le justificatif");
    }
  };

  if (value) {
    return (
      <div className="flex items-center justify-between rounded-lg border border-slate-200 bg-slate-50 px-3 py-2" data-testid="receipt-attached">
        <span className="truncate text-sm text-slate-700">{value.original_filename || "Justificatif"}</span>
        <div className="flex items-center gap-2">
          <button type="button" onClick={view} data-testid="receipt-view-button" className="rounded-md p-1.5 text-primary hover:bg-emerald-50"><Eye className="h-4 w-4" /></button>
          <button type="button" onClick={() => onChange(null)} data-testid="receipt-remove-button" className="rounded-md p-1.5 text-slate-400 hover:bg-slate-100"><X className="h-4 w-4" /></button>
        </div>
      </div>
    );
  }

  return (
    <label data-testid="receipt-upload-label" className="flex cursor-pointer items-center justify-center gap-2 rounded-lg border border-dashed border-slate-300 bg-white px-3 py-3 text-sm text-slate-500 hover:border-primary hover:text-primary">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Paperclip className="h-4 w-4" />}
      {busy ? "Envoi…" : "Ajouter un justificatif (photo/PDF)"}
      <input type="file" accept="image/*,application/pdf" capture="environment" className="hidden" onChange={onFile} data-testid="receipt-file-input" disabled={busy} />
    </label>
  );
}
